import { BulletList } from '../../BulletList'
import { Container } from '../Container'

function BulletLists() {
  return (
    <>
      <Container label='BulletList'>
        <div>
          <BulletList
            value={[
              'Checklist',
              '08/12/2022',
              'Edenkobener Str.1-9',
              'No. 1245 Domicil',
              'Jeremy Stivenson | Manager',
            ]}
          />
          <BulletList value={[1, true, 'foo', 'bar', null, null]} />
        </div>
      </Container>
    </>
  )
}

export default BulletLists
